import { ReportDefinition, ReportMetaDataContext, TargetEntityType } from "./reportMetaData";
import { Helper } from "../core/util/helper";
import { ReportMetaDataHelper } from "./reportMetaDataHelper";
import React from "react";
export default class UsableParameters extends React.Component<UsableParametersProps, UsableParametersState>{
    constructor(props: UsableParametersProps) {
        super(props)
        this.state = {
            type: props.entity.TargetEntityType
        }
    }

    componentDidUpdate() {
        if (this.state.type !== this.props.entity.TargetEntityType) {
            this.setState({ type: this.props.entity.TargetEntityType });
        }
    }

    render() {
        if (!Helper.isNullOrEmpty(this.state.type.toString())) {
            const params: string[] = this.props.context.qrParameters[ReportMetaDataHelper.getTargetEntityTypeName(this.state.type)].sort()
            return (
                <div style={{ padding: "5px" }}>
                    <label>{this.props.context.translations["WebSMS.ReportMetadata.FollowingParametersSupported"]}</label>
                    <div style={{ marginLeft: "22px", paddingTop: "8px" }}>
                        <ul style={{ listStyle: "disc" }}>
                            {params.map((p) => { return (<li key={kendo.guid()} style={{ margin: "2px" }}>{p}</li>) })}
                        </ul>
                    </div>
                </div>
            );
        } else {
            return null;
        }
    }
}

interface UsableParametersProps {
    entity: ReportDefinition;
    context: ReportMetaDataContext;
}

interface UsableParametersState {
    type: TargetEntityType
}